// EXEC240: one editable table for the rows of a schedule (assets, journals, loans, events …). Columns name a key path
// ("ref.evidence_id"), so source references sit next to the figure they support. Empty stays empty: nothing is defaulted.
export const getPath=(o,path)=>path.split('.').reduce((v,k)=>v==null?undefined:v[k],o);
export const setPath=(o,path,value)=>{const [k,...rest]=path.split('.');const base=o&&typeof o==='object'?o:{};
 return {...base,[k]:rest.length?setPath(base[k],rest.join('.'),value):value};};
// Child rows (transfers of an asset, events of a loan) are edited in one table that names their parent by position.
export const flatten=(parents,key)=>parents.flatMap((p,parent)=>(p[key]||[]).map(child=>({...child,parent})));
export const nest=(parents,key,rows)=>parents.map((p,i)=>({...p,[key]:rows.filter(r=>r.parent===i).map(({parent,...child})=>child)}));

export const refColumns=(prefix,evidence)=>[
 {key:`${prefix}.evidence_id`,label:'Bukti',type:'select',options:evidence},
 {key:`${prefix}.source_locator`,label:'Lokasi sumber'},
 {key:`${prefix}.source_cell`,label:'Sel / referensi'},
 {key:`${prefix}.source_formula`,label:'Rumus tercatat'}];

function Cell({column,row,index,label,onEdit}){
 const value=getPath(row,column.key);
 const aria=`${label} ${index+1} ${column.label}`;
 if(column.type==='select'){
  const options=typeof column.options==='function'?column.options(row):column.options||[];
  return <select aria-label={aria} className="border" value={value==null?'':String(value)} onChange={e=>onEdit(e.target.value===''?(column.number?null:''):column.number?Number(e.target.value):e.target.value)}>
   <option value="">—</option>{options.map(([v,text])=><option key={String(v)} value={String(v)}>{text}</option>)}</select>;
 }
 return <input aria-label={aria} className="border w-28" type={column.type==='date'?'date':'text'} value={value??''} onChange={e=>onEdit(e.target.value)}/>;
}

export default function ScheduleTable({label,columns,rows,onChange,newRow,disabled,testid}){
 const edit=(i,path,value)=>onChange(rows.map((r,j)=>j===i?setPath(r,path,value):r));
 return <fieldset className="border p-2 my-2" data-testid={testid}><legend className="font-semibold">{label}</legend>
  <div className="overflow-x-auto"><table className="text-[11px]"><thead><tr>{columns.map(c=><th key={c.key} className="text-left pr-1">{c.label}</th>)}<th/></tr></thead>
   <tbody>{rows.map((row,i)=><tr key={i}>{columns.map(c=><td key={c.key}><Cell column={c} row={row} index={i} label={label} onEdit={v=>edit(i,c.key,v)}/></td>)}
    <td><button type="button" aria-label={`Hapus ${label} ${i+1}`} onClick={()=>onChange(rows.filter((_,j)=>j!==i))}>×</button></td></tr>)}</tbody></table></div>
  <button type="button" disabled={disabled} onClick={()=>onChange([...rows,newRow(rows.length)])}>Tambah baris {label.toLowerCase()}</button>
 </fieldset>;
}
